import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography, Button } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TableV2, CustomFilterV2 } from '../../../components/v2';
import * as selectorsGerencias from '../../../store/gerencia/reducer';
import * as actionsGerencias from '../../../store/gerencia/actions';
import Formulario from './Formulario';

const Gerencias = ({ gerencias, loadGerencias, deleteGerencia }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [localFilter, setLocalFilter] = useState({});

  useEffect(() => {
    loadGerencias();
  }, [loadGerencias]);

  const columns = [
    { field: 'codigo', headerName: 'Código', flex: 0.4 },
    { field: 'nome', headerName: 'Nome', flex: 1 },
    { field: 'malhaCodigo', headerName: 'Malha', flex: 0.5 },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Gerências</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={gerencias}
          columns={columns}
          onEdit={id => { setOpen(true); setId(id); }}
          onDelete={id => deleteGerencia(id)}
          headerActions={[
            { label: 'Novo', onClick: () => { setOpen(true); setId(null); }, startIcon: <AddIcon />, variant: 'contained' },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useCodigo', md: 4 },
            { field: 'useMalha', md: 4 },
          ]}
          onFilter={filterData => {
            setLocalFilter(filterData);
            loadGerencias(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadGerencias();
          }}
          gerencias={gerencias}
        />
      </Stack>
    </Box>
  );
};

Gerencias.propTypes = {
  deleteGerencia: PropTypes.func.isRequired,
  loadGerencias: PropTypes.func.isRequired,
  gerencias: PropTypes.array,
};

const mapStateToProps = state => ({
  gerencias: selectorsGerencias.getGerencias(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsGerencias
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Gerencias));
